var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_tUw9DqAX0xgh0fL0qCCZlKppZt4T03U0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_tUw9DqAX0xgh0fL0qCCZlKppZt4T03U0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 17.500000000000004,
    cy: 17.5,
    r: 17.500000000000043
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 17.5 24.736 C 18.495 24.736 19.309 23.922 19.309 22.927 L 19.309 12.073 C 19.309 11.078 18.495 10.264 17.5 10.264 C 16.505 10.264 15.691 11.078 15.691 12.073 L 15.691 22.927 C 15.691 23.922 16.505 24.736 17.5 24.736 Z  M 12.073 24.736 C 13.068 24.736 13.882 23.922 13.882 22.927 L 13.882 19.309 C 13.882 18.314 13.068 17.5 12.073 17.5 C 11.078 17.5 10.264 18.314 10.264 19.309 L 10.264 22.927 C 10.264 23.922 11.078 24.736 12.073 24.736 Z  M 21.118 16.595 L 21.118 22.927 C 21.118 23.922 21.932 24.736 22.927 24.736 C 23.922 24.736 24.736 23.922 24.736 22.927 L 24.736 16.595 C 24.736 15.6 23.922 14.786 22.927 14.786 C 21.932 14.786 21.118 15.6 21.118 16.595 Z ",
    fill: "rgb(255,255,255)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.dbd6f7dcf55ea6ad2891fcaebfb790f9.svg";
export { ForwardRef as ReactComponent };